import { createAction, props } from '@ngrx/store';

export const GET_ALL_PRESS = '[Press] Get All Press';
export const GET_ALL_PRESS_SUCCESS = '[Press] Get All Press Success';
export const GET_ALL_PRESS_FAILURE = '[Press] Get All Press Failure';

export const GET_ALL_BLOG_POST = '[Blog] Get All Blog Post';
export const GET_ALL_BLOG_POST_SUCCESS = '[Blog] Get All Blog Post Success';
export const GET_ALL_BLOG_POST_FAILURE = '[Blog] Get All Blog Post Failure';

// Mega Menu
export const GET_ALL_MEGA_MENU = '[Mega menu] Get All Mega menu';
export const GET_ALL_MEGA_MENU_SUCCESS =
  '[Mega menu] Get All Mega menu Success';
export const GET_ALL_MEGA_MENU_FAILURE =
  '[Mega menu] Get All Mega menu Failure';

//CTA-Footer Links
export const GET_ALL_FOOTER_LINKS = '[Footer] Get All Footer Links';
export const GET_ALL_FOOTER_LINKS_SUCCESS =
  '[Footer] Get All Footer Links Success';
export const GET_ALL_FOOTER_LINKS_FAILURE =
  '[Footer] Get All Footer Links Failure';

//Quick Links
export const GET_ALL_QUICK_LINKS = '[Footer] Get All Quick Links';
export const GET_ALL_QUICK_LINKS_SUCCESS =
  '[Footer] Get All Quick Links Success';
export const GET_ALL_QUICK_LINKS_FAILURE =
  '[Footer] Get All Quick Links Failure';

// Site-settings
export const GET_ALL_SITE_SETINGS = '[Settings] Get All Site Settings';
export const GET_ALL_SITE_SETTINS_SUCCESS =
  '[Settings] Get All Site Settings Success';
export const GET_ALL_SITE_SETTINGS_FAILURE =
  '[Settings] Get All Site Settings Failure';

// traveller stories

export const GET_TRAVELLER_STORIES = '[Stories] Get  Traveller Stories';
export const GET_TRAVELLER_STORIES_SUCCESS =
  '[Settings] Get Traveller Stories Success';
export const GET_TRAVELLER_STORIES_FAILURE =
  '[Settings] Get Traveller Stories Failure';

//Package Category
export const GET_PACKAGE_CATEGORY = '[Package Category] Get  Package Category';
export const GET_PACKAGE_CATEGORY_SUCCESS =
  '[Package Category] Get  Package Category Success';
export const GET_PACKAGE_CATEGORY_FAILURE =
  '[Package Category] Get  Package Category Failure';

// Hero Banners
export const GET_ALL_HERO_BANNERS = '[Settings] Get All Hero Banners';
export const GET_ALL_HERO_BANNERS_SUCCESS =
  '[Hero Banners] Get All Hero Banners Success';
export const GET_ALL_HERO_BANNERS_FAILURE =
  '[Hero Banners] Get All Hero Banners Failure';

// Package Themes
export const GET_ALL_PACKAGE_THEMES = '[Package Themes] Get All Package Themes';
export const GET_ALL_PACKAGE_THEMES_SUCCESS =
  '[Package Themes] Get All Package Themes Success';
export const GET_ALL_PACKAGE_THEMES_FAILURE =
  '[Package Themes] Get All Package Themes Failure';

// Blog Categories
export const GET_ALL_BLOG_CATEGORIES =
  '[Blog Categories] Get All Blog Categories';
export const GET_ALL_BLOG_CATEGORIES_SUCCESS =
  '[Blog Categories] Get All Blog Categories Success';
export const GET_ALL_BLOG_CATEGORIES_FAILURE =
  '[Blog Categories] Get All Blog Categories Failure';

// Exclusive Deals
export const GET_EXCLUSIVE_DEALS = '[Exclusive Deals] Get Exclusive Deals';
export const GET_EXCLUSIVE_DEALS_SUCCESS =
  '[Exclusive Deals] Get Exclusive Deals Success';
export const GET_EXCLUSIVE_DEALS_FAILURE =
  '[Exclusive Deals] Get Exclusive Deals Failure';

//Explore Packages
//CTA-Footer Links
export const GET_ALL_EXPLORE_PACKAGES =
  '[Explore Package] Get All Explore Package';
export const GET_ALL_EXPLORE_PACKAGES_SUCCESS =
  '[Explore Package] Get All Explore Package Success';
export const GET_ALL_EXPLORE_PACKAGES_FAILURE =
  '[Explore Package] Get All Explore Package Failure';

export const getAllPress = createAction(GET_ALL_PRESS);

export const getAllPressSuccess = createAction(
  GET_ALL_PRESS_SUCCESS,
  props<{ data: any }>()
);

export const getAllPressFailure = createAction(
  GET_ALL_PRESS_FAILURE,
  props<{ data: any }>()
);

// MegaMenu Links
export const getAllMegaMenu = createAction(GET_ALL_MEGA_MENU);

export const getAllMegaMenuSuccess = createAction(
  GET_ALL_MEGA_MENU_SUCCESS,
  props<{ data: any }>()
);

export const getAllMegaMenuFailure = createAction(
  GET_ALL_MEGA_MENU_FAILURE,
  props<{ data: any }>()
);

//Footer-CTA Links

export const getAllFooterLinks = createAction(GET_ALL_FOOTER_LINKS);

export const getAllFooterLinksSuccess = createAction(
  GET_ALL_FOOTER_LINKS_SUCCESS,
  props<{ data: any }>()
);

export const getAllFooterLinksFailure = createAction(
  GET_ALL_FOOTER_LINKS_FAILURE,
  props<{ data: any }>()
);

//Quick Links

export const getAllQuickLinks = createAction(GET_ALL_QUICK_LINKS);

export const getAllQuickLinksSuccess = createAction(
  GET_ALL_QUICK_LINKS_SUCCESS,
  props<{ data: any }>()
);

export const getAllQuickLinksFailure = createAction(
  GET_ALL_QUICK_LINKS_FAILURE,
  props<{ data: any }>()
);

// Site-settings
export const getAllSiteSettings = createAction(GET_ALL_SITE_SETINGS);

export const getAllSiteSettingsSuccess = createAction(
  GET_ALL_SITE_SETTINS_SUCCESS,
  props<{ data: any }>()
);

export const getAllSiteSettingsFailure = createAction(
  GET_ALL_SITE_SETTINGS_FAILURE,
  props<{ data: any }>()
);

// Hero-banners
export const getAllHeroBanners = createAction(GET_ALL_HERO_BANNERS);

export const getAllHeroBannersSuccess = createAction(
  GET_ALL_HERO_BANNERS_SUCCESS,
  props<{ data: any }>()
);

export const getAllHeroBannersFailure = createAction(
  GET_ALL_HERO_BANNERS_FAILURE,
  props<{ data: any }>()
);

// Package themes
export const getAllPackageThemes = createAction(GET_ALL_PACKAGE_THEMES);

export const getAllPackageThemesSuccess = createAction(
  GET_ALL_PACKAGE_THEMES_SUCCESS,
  props<{ data: any }>()
);

export const getAllPackageThemesFailure = createAction(
  GET_ALL_PACKAGE_THEMES_FAILURE,
  props<{ data: any }>()
);

// Blog categories
export const getAllBlogCategories = createAction(GET_ALL_BLOG_CATEGORIES);

export const getAllBlogCategoriesSuccess = createAction(
  GET_ALL_BLOG_CATEGORIES_SUCCESS,
  props<{ data: any }>()
);

export const getAllBlogCategoriesFailure = createAction(
  GET_ALL_BLOG_CATEGORIES_FAILURE,
  props<{ data: any }>()
);

// Action to initiate the API call for exclusive deals
export const getExclusiveDeals = createAction(
  GET_EXCLUSIVE_DEALS,
  props<{ data: any; minimal: boolean }>() // Pass the data and the minimal flag
);

// Action to handle the success response
export const getExclusiveDealsSuccess = createAction(
  GET_EXCLUSIVE_DEALS_SUCCESS,
  props<{ data: any }>() // This will hold the successful response data
);

// Action to handle the failure response
export const getExclusiveDealsFailure = createAction(
  GET_EXCLUSIVE_DEALS_FAILURE,
  props<{ error: any }>() // This will hold the error response
);

// Traveller Stories

export const getTravellerStories = createAction(
  GET_TRAVELLER_STORIES,
  props<{ data: any; minimal: boolean }>()
);

export const getTravellerStoriesSuccess = createAction(
  GET_TRAVELLER_STORIES_SUCCESS,
  props<{ data: any }>()
);

export const getTravellerStoriesFailure = createAction(
  GET_TRAVELLER_STORIES_FAILURE,
  props<{ error: any }>()
);

//Package Category API
export const getPackageCategory = createAction(GET_PACKAGE_CATEGORY);

export const getPackageCategorySuccess = createAction(
  GET_PACKAGE_CATEGORY_SUCCESS,
  props<{ data: any }>()
);

export const getPackageCategoryFailure = createAction(
  GET_PACKAGE_CATEGORY_FAILURE,
  props<{ data: any }>()
);

//Explore Packages

export const getAllExplorePackages = createAction(GET_ALL_EXPLORE_PACKAGES);

export const getAllExplorePackagesSuccess = createAction(
  GET_ALL_EXPLORE_PACKAGES_SUCCESS,
  props<{ data: any }>()
);

export const getAllExplorePackagesFailure = createAction(
  GET_ALL_EXPLORE_PACKAGES_FAILURE,
  props<{ data: any }>()
);

//Explore Blog Post
export const getAllBlogPost = createAction(GET_ALL_BLOG_POST);

export const getAllBlogPostSuccess = createAction(
  GET_ALL_BLOG_POST_SUCCESS,
  props<{ data: any }>()
);

export const getAllBlogPostFailure = createAction(
  GET_ALL_BLOG_POST_FAILURE,
  props<{ data: any }>()
);
